import React = require("react");
import {Title} from "../../../components/Title";

import {CardBoxSmall} from "../../../components/CardBox";
import {Loader} from "../../../components/Utils/loader/Loader";
import {PrettyPrinter} from "../../../components/Utils/PrettyPrinter";
import {MarketingConfig, UNITS_UNIT_OF_MEASURE_CODE} from "../data/MarketingConfig";
import UnitOfMeasure = MarketingConfig.UnitOfMeasure;
import {MarketingData} from "../data/MarketingData";
import "./AssetBaseWidget.scss";
import MarketingDataConverter = MarketingData.MarketingDataConverter;
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {Display} from "../../../components/Display";
import {Tooltip} from "@vebox/etui-core";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";

export interface EntityCount {
    name: string;
    count: number;
}

interface AssetBaseWidgetProps {
    title: string;
    locations: EntityCount;
    telemetryKits: EntityCount;
    selections: EntityCount;
    unitOfMeasure: UnitOfMeasure;
}

declare var AppTranslations: AppTranslations;

/**
 * Representation of a value with the unit measure.
 */
export class AssetBaseWidget extends React.Component<AssetBaseWidgetProps, any> {
    constructor(props: AssetBaseWidgetProps) {
        super(props);
    }

    public render() {
        return (
            <VeBoxCard className="marketing-widget marketing-widget-asset-base no-margin">
                <VeBoxCard.Header
                    title={this.props.title}
                    back={(
                        <Tooltip message={AppTranslations.siteMarketing.assetBaseInfo} styles={{bubble: {width: 200}}}>
                            <span className={"material-icons-outlined"}>info</span>
                        </Tooltip>
                    )}
                    className={"flex-just-cont-space-between"}
                />
                <VeBoxCard.Body
                    className="marketing-widget__content widget-row centered"
                    style={{padding: 0}}
                >
                    <CardBoxSmall
                        title={this.props.locations.name}
                        value={PrettyPrinter.salesQuantity(this.props.locations.count)}
                    />
                    <CardBoxSmall
                        title={this.props.telemetryKits.name}
                        value={PrettyPrinter.salesQuantity(this.props.telemetryKits.count)}
                    />
                    <Display isVisible={!MarketingDataConverter.isUnitsUnitOfMeasure(this.props.unitOfMeasure)}>
                        <CardBoxSmall
                            title={this.props.selections.name}
                            value={PrettyPrinter.salesQuantity(this.props.selections.count)}
                        />
                    </Display>
                </VeBoxCard.Body>
            </VeBoxCard>
        );
    }
}
